// A mobile-app webview opens an interaction page as the TOP-LEVEL document, whereas on the web the
// widget is always inside a publisher iframe. Standalone there is no bild.de parent to mint the
// participation token (hyper only runs on the publisher page), so the login cookie can never be used
// and autofill silently falls back to the manual form. This resolves the hand-off target: the
// iat.<stage>.la.bild.de/embed wrapper, which runs hyper on a bild.de origin and re-embeds the widget.
//
// Only the two deployed widget hosts ever redirect, each to the wrapper of its own stage, so staging
// never lands on prod and local/dev/unknown hosts are never touched. Returns undefined whenever the
// page must be left alone: embedded, no id, unknown host, or no page name to derive the type from.
//
// INTERIM, DELIBERATELY BRAND-BLIND: the widget host is shared, so a standalone WELT/BZ interaction
// also lands on the BILD wrapper and hyper then picks BILD's session endpoint and login. That is
// accepted for now -- cross-brand sharing is planned but not active, and the identity layer is being
// replaced, so a brand-aware wrapper router would be premature. It costs non-BILD standalone URLs one
// extra wrapper/iframe layer (rendering only; autofill stays off until their identity path exists).
// Before rollout, smoke-test one non-BILD standalone interaction for navigation, rendering and
// resizing. When identity is replaced, map the wrapper origin per brand here instead of per stage.

const WRAPPER_ORIGIN_BY_WIDGET_HOST: Record<string, string> = {
  "interactive-web.la.spring-media.de": "https://iat.la.bild.de",
  "interactive-web.staging.la.spring-media.de":
    "https://iat.staging.la.bild.de",
};

export function standaloneRedirectUrl(
  hostname: string,
  pathname: string,
  search: string,
  embedded: boolean
): string | undefined {
  if (embedded) {
    return undefined;
  }
  const wrapperOrigin = WRAPPER_ORIGIN_BY_WIDGET_HOST[hostname];
  if (!wrapperOrigin) {
    return undefined;
  }
  const params = new URLSearchParams(search);
  if (!params.get("id")) {
    return undefined;
  }
  // quiz.html -> quiz. The wrapper re-embeds <type>.html, so the round trip lands on the same widget.
  const interactionType = (pathname.split("/").pop() || "").replace(
    /\.html$/,
    ""
  );
  if (!interactionType) {
    return undefined;
  }
  params.set("type", interactionType);
  return `${wrapperOrigin}/embed?${params.toString()}`;
}
